import { render, staticRenderFns } from "./serveiceCtrl.vue?vue&type=template&id=bdbbae6c&scoped=true&"
import script from "./serveiceCtrl.vue?vue&type=script&lang=js&"
export * from "./serveiceCtrl.vue?vue&type=script&lang=js&"
import style0 from "./serveiceCtrl.vue?vue&type=style&index=0&id=bdbbae6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbbae6c",
  null
  
)

export default component.exports